// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/settings.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { SettingsService } from "./settings_pb";

/**
 * ListSettings returns every setting, ordered by key.
 *
 * @generated from rpc travplaces.v1.SettingsService.ListSettings
 */
export const listSettings = SettingsService.method.listSettings;
